import Vue from "vue"
import VueI18n, { LocaleMessages } from "vue-i18n"
import Cookies from "js-cookie"

Vue.use(VueI18n)

const userLanguage = window.navigator.language
const availableLocales: string[] = []

const sourceLocales = require.context("@/locales/source", false, /[A-Za-z0-9-_,\s]+\.json$/i)
const translationLocales = require.context(
    "@/locales/translations",
    false,
    /[A-Za-z0-9-_,\s]+\.json$/i,
)

const messages: LocaleMessages = {}

sourceLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
        const locale = matched[1]
        availableLocales.push(locale)
        messages[locale] = sourceLocales(key)
    }
})

translationLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
        const locale = matched[1]
        availableLocales.push(locale)
        messages[locale] = translationLocales(key)
    }
})

let locale = process.env.DEFAULT_LOCALE || "en"

if (userLanguage && availableLocales.includes(userLanguage.split(/-|_/)[0])) {
    locale = userLanguage.split(/-|_/)[0]
}

const userDefinedLocale = Cookies.get("locale")

if (userDefinedLocale !== undefined) {
    locale = userDefinedLocale
}

export default new VueI18n({
    locale: locale,
    messages: messages,
    silentTranslationWarn: true,
    dateTimeFormats: {
        en: {
            time: {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            },
            date: {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            },
            datetime: {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            },
        },
        sl: {
            time: {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            },
            date: {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            },
            datetime: {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            },
        },
    },
    pluralizationRules: {
        sl: function (choice, choicesLength) {
            if (choice === 0) {
                return 0
            }

            if (choice === 1) {
                return 1
            }

            if (choice === 2) {
                return 2
            }

            if (choice === 3 || choice === 4) {
                return 3
            }

            return 0
        },
    },
})
